/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZohoServiceDeskIncidentManagementConfigurationRequester {
    getFixupPrototypeFunction() { return ZohoServiceDeskIncidentManagementConfigurationRequester.fixupPrototype; }

    static newInstance(model: Partial<ZohoServiceDeskIncidentManagementConfigurationRequester>): ZohoServiceDeskIncidentManagementConfigurationRequester {
        let obj = Object.assign(new ZohoServiceDeskIncidentManagementConfigurationRequester(), model);
        ZohoServiceDeskIncidentManagementConfigurationRequester.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZohoServiceDeskIncidentManagementConfigurationRequester>): ZohoServiceDeskIncidentManagementConfigurationRequester {
        if (!model) return null;
        return ZohoServiceDeskIncidentManagementConfigurationRequester.newInstance(<ZohoServiceDeskIncidentManagementConfigurationRequester> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZohoServiceDeskIncidentManagementConfigurationRequester) {
        if (!obj) return;

        models.ZohoServiceDeskIncidentManagementConfigurationRequester.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZohoServiceDeskIncidentManagementConfigurationRequester): boolean {
        Object.setPrototypeOf(obj, ZohoServiceDeskIncidentManagementConfigurationRequester.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the requester
     */
    user_id: string;

    /**
     * Name for requester
     */
    user_name: string;

}
